import { simbaStyled } from '@naf-simba/theme';

export const Header = simbaStyled('div')(() => ({}));

export const Title = simbaStyled('div')(({ theme }) => ({
  marginTop: 0,
  marginBottom: theme.spacing('ml'),
}));

export const Ingress = simbaStyled('div')(({ theme }) => ({
  marginTop: theme.spacing('ml'),
  marginBottom: theme.spacing('ml'),
}));

export const LoginButtonWrapper = simbaStyled('div')(({ theme }) => ({
  marginTop: theme.spacing('ml'),
}));
